import { Component, OnInit, OnDestroy } from "@angular/core";
import { DialogService } from "@progress/kendo-angular-dialog";
import { MDMService } from "app/reusable/mdm.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AccountModel } from "../Models/AccountModel";
import { UserAccountDetailsComponent } from "../user-account-details/user-account-details.component";

@Component({
    selector: "app-user-accounts-list",
    templateUrl: "./user-accounts-list.component.html",
  })



  export class UserAccountListComponent implements OnInit, OnDestroy {

    private _subject$: Subject<boolean> = new Subject();
    accounts : AccountModel[] = [];
    itemSelected :AccountModel = null;

    
    constructor(
        private mdmService: MDMService,
        private dialogService: DialogService
      ) {}

    ngOnInit(): void {
        this.getAccounts();
    }

    getAccounts(){        
        this.mdmService
        .getAccounts()
        .pipe(takeUntil(this._subject$))
        .subscribe((data : any) => {
            this.accounts = data;
        });
    }

    openDialog(selectedItem){
        const dialogRef = this.dialogService.open({
          minWidth: "700px",
          content: UserAccountDetailsComponent,
      });
      dialogRef.content.instance.selectedItem = selectedItem;
      dialogRef.result.subscribe((r) => {
        if (r == true) {
          this.getAccounts();
        }
      });
    }

    dblClickEvent() { 
      if(this.itemSelected != null)
      this.mdmService
            .getAccountById(this.itemSelected.id)
            .pipe(takeUntil(this._subject$))
            .subscribe((data : any) => {
              this.itemSelected = data;
              this.openDialog(this.itemSelected);
              this.itemSelected = null;
            });     
    }
   
    onCellClick($event) {
      this.itemSelected = $event.dataItem
    }
    ngOnDestroy(): void {
        this._subject$.unsubscribe();
    }
  }